import { DatePipe } from "@angular/common";
import { Component, Inject, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { Subscription } from "rxjs";
import { EncounterModel } from "../../interface/Iencounter";
import { OPD_CONST } from "../../properties/opd-static-properties";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
import { OPD_API_URL } from "../../properties/opd-url-properties";
import { OrderstatusComponent } from "../orderstatus/orderstatus.component";
import { UploadfileComponent } from "../uploadfile/uploadfile.component";
import { saveAs } from "file-saver";
import { APPLICATIONSERVICE } from "projects/lib/medcare-core-lib/src/lib/constants/application-service";
import { MICROSERVICES } from "projects/lib/medcare-core-lib/src/lib/constants/web-services";
import { ConfirmDynamicDialogComponent } from "projects/lib/medcare-core-lib/src/lib/core/confirm-dynamic-dialog/confirm-dynamic-dialog.component";
import { MultiLanguageService } from "projects/lib/medcare-core-lib/src/lib/core/multi-language/multi-language.service";
import { DocumentUploadEnum } from "projects/lib/medcare-core-lib/src/lib/enums/configuration-modules.enum";
import { FileUploadService } from "projects/lib/medcare-core-lib/src/lib/services/file-upload.service";
import { AppBaseService } from "projects/lib/medcare-core-lib/src/lib/services/http.service";
import { ViewDocumentComponent } from "../view-document/view-document.component";

@Component({
  selector: "app-documentupload",
  templateUrl: "./documentupload.component.html",
  styleUrls: ["./documentupload.component.scss"],
  providers: [DatePipe],
})
export class DocumentuploadComponent implements OnInit, OnDestroy {
  @ViewChild(MatSort) sort: MatSort;
  private subscriptionList = new Subscription();
  fileUploadColumns = OPD_CONST.fileUploadColumns;
  fileSource = new MatTableDataSource();
  list: any = [];
  isSave: boolean = false;
  documentList: any[] = [];
  documentTypelist: any[] = [];
  docTypeList: any[] = [];
  docTypeFilteredList: any[] = [];
  docTypeSearch: FormControl = new FormControl();
  formData: FormData = new FormData();
  _onDestroy: Subject<boolean> = new Subject<boolean>();
  docList: any[]=[];
  invalidDocumentIndices: number[] = [];
  constructor(
    public dialog: MatDialog,
    private sfileUploadService: FileUploadService,
    public dialogRef: MatDialogRef<OrderstatusComponent>,
    private appBaseService: AppBaseService,
    public datepipe: DatePipe,
    public snackBar: MatSnackBar,
    private langService: MultiLanguageService,
    @Inject(MAT_DIALOG_DATA) public data: EncounterModel
  ) {}

  ngOnInit() {
    this.searchOnChanges();
    this.getDocTypeyList();
    this.getDocTypeList();
    this.getDocumentTypeList();
  }

  /**
   *destroy method
   *
   * @memberof DocumentuploadComponent
   */
  ngOnDestroy() {
    this.subscriptionList.unsubscribe();
    this._onDestroy.next(true);
    this._onDestroy.complete();
  }

  /**
   *search changes method
   *
   * @memberof DocumentuploadComponent
   */
  searchOnChanges() {
    this.subscriptionList.add(
      this.docTypeSearch.valueChanges.subscribe((value) => {
        this.docTypeFilteredList = this.docTypeList.filter((i) =>
          i.desc.toString().toLowerCase().includes(value.toLowerCase())
        );
      })
    );
  }
  getDocumentTypeList() {
    this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
    this.appBaseService
      .getResource(OPD_API_URL.DOCUMENTTYPEMASTER,true)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.documentTypelist = res;
      });
  }

  /**
   *Get documents
   *
   * @memberof DocumentuploadComponent
   */
  getDocuments() {
    this.documentList = [];
    let payload={
      mrn:this.data.MRN,
      visitNo:this.data.EncounterNumber,
      offset: 0,
      limit: 10,
      screenCode:this.data.screenCode
    }
    this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
    this.appBaseService
      .postResource(APPLICATIONSERVICE.GET_DOCUMENT,payload)
      .subscribe((res) => {
        if (res.payload) {
          res.payload.fileResponse.forEach((element) => {
            let fileTypeValue=this.documentTypelist.find((data)=>{return data.desc==element.docVersion});
            const parts = element.filePath.split('=>');
            const docTypeValue = parts[1];
            let docListValue = this.docList.find((data) => {
              return data.desc == docTypeValue;
            });
            this.documentList.push({
              doctype:docListValue?docListValue.code:'',
              fileDescription: element.documentName,
              fileName: element.fileName,
              fileLocation: element.fileLocation,
              id: element.id,
              files: element.files,
              fileType: fileTypeValue
              ? fileTypeValue.code
              : "",
              isOldFile: true,
            });
          });
          this.fileSource = new MatTableDataSource(this.documentList);
        }
      });
  }

  /**
   *get document type list method
   *
   * @memberof DocumentuploadComponent
   */
  getDocTypeyList() {
    this.appBaseService.setResourceURL(MICROSERVICES.MASTERS_SERVICE);
    this.subscriptionList.add(
      this.appBaseService
        .getResource(OPD_API_URL.M_DOC_TYPE,true)
        .subscribe((res) => {
          this.docTypeList = res;
          this.docTypeFilteredList = res;
          this.getDocuments();
        })
    );
  }

  /**
   *Update file list
   *
   * @param {*} fileType
   * @param {*} res
   * @memberof DocumentuploadComponent
   */
  upadteFileList(fileType, res) {
    this.documentList.find(
      (item) => item.fileName == res.fileName && item.isOld == false
    ).filetypevalue = fileType;
  }

  /**
   *update file desc method
   *
   * @param {*} filedesc
   * @param {*} res
   * @memberof DocumentuploadComponent
   */
  updateFiledesc(filedesc, res) {
    this.documentList.find(
      (item) => item.fileName == res.fileName && item.isOld == false
    ).description = filedesc;
  }

  /**
   *file upload method
   *
   * @memberof DocumentuploadComponent
   */
  fileUploadDialog() {
    const dialogRef = this.dialog.open(UploadfileComponent, {
      height: "auto",
      width: "300px",
      data: { mrn: this.data.MRN, encounter: this.data.EncounterNumber },
    });
    dialogRef.afterClosed().subscribe((res) => {
      res.forEach((element) => {
        this.documentList.push({
          fileType: DocumentUploadEnum.FINAL,
          fileName: element.name,
          id: element.id,
          files: element.files,
          filetypevalue: "",
          docFileType: "",
          fileDescription:  element.name,
          isOld: false,
          screenCode:this.data.screenCode
        });
      });
      this.fileSource = new MatTableDataSource(this.documentList);
    });
  }

  /**
   *save upload method
   *
   * @memberof DocumentuploadComponent
   */
  saveupload() {
      let doctType=this.documentList.find((i) => i.doctype =='' ||i.doctype ==undefined);
      if(!doctType){
      let exits = this.documentList.find((i) => i.isOld == false);
      let list = [];
      list = this.documentList;
      if (exits) {
        this.sfileUploadService.getFileUpload(
          list,
          this.data.MRN,
          this.data.EncounterNumber,
          "ADMINISTRATIVE",
          "VISIT"
        );
        this.isSave = true;
        this.onNoClick();
      } else {
        this.snackBar.open(
          this.langService.get("CommonAppoinment.pleaseuploadnewfiles"),
          this.langService.get("CommonAppoinment.validation"),
          {
            duration: 3000,
          }
        );
        this.isSave = false;
      }
    } else {
      this.snackBar.open("Warning", "Please select the Document Type", {
        duration: 2000,
      });
    }
  }

  /**
   *Document Download
   *
   * @param {*} e
   * @memberof DocumentuploadComponent
   */
  fileDownload(e) {
    this.appBaseService.setResourceURL(OPD_API_URL.FILE_SERVICE);
    this.appBaseService
      .getBlobFileResource(OPD_API_URL.OPD_FILE_DOWNLOAD_ID + e.id)
      .subscribe((res) => {
        const blob = new Blob([res], { type: res.type });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      });
  }

  /**
   * To download a file
   *
   * @param element
   * @memberof DocumentuploadComponent
   */
  downloadFile(element) {
    this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
    this.appBaseService
      .getMIMETypeResource(OPD_API_URL.OPD_DOWNLOAD_FILE + element.id)
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        var b = new Blob([res], { type: res.type });
        saveAs(b, element.fileName);
        // var fileURL = URL.createObjectURL(res);
        // window.open(fileURL); // if you want to open it in new tab
      });
  }

  /**
   * Confirmation popup for delete file
   *
   * @param {*} element
   * @param {*} isfromReg
   * @memberof PatientRegistrationComponent
   */
  confirmDelete(element) {
    const dialogRef = this.dialog.open(ConfirmDynamicDialogComponent, {
      width: "30%",
      data: { displayText: "deleteConfirm" },
    });
    this.subscriptionList.add(
      dialogRef.afterClosed().subscribe((result) => {
        if (result != undefined && result.confirm && result.confirm == "yes") {
          this.removeFile(element);
        }
      })
    );
  }

  /**
   *remove File
   *
   * @param {*} element
   * @param {*} isfromReg
   * @memberof PatientRegistrationComponent
   */
  removeFile(element) {
    const index: number = this.fileSource.data.indexOf(element);
    if (index != -1) {
      if (!element.isOldFile) {
        this.fileSource.data.splice(index, 1);
        this.fileSource = new MatTableDataSource(this.fileSource.data);
      } else {
        this.appBaseService.setResourceURL(OPD_API_URL.DOC_SERVICE);
        this.appBaseService
          .deleteResource(OPD_API_URL.REMOVE_UPLODED_FILE + element.id)
          .pipe(takeUntil(this._onDestroy))
          .subscribe((response: any) => {
            if (response.statusCode == "200") {
              this.snackBar.open(
                this.langService.get("EncounterPage.fileDeletedSucces"),
                this.langService.get("CommonAppoinment.success"),
                {
                  duration: 1000,
                }
              );
              this.fileSource.data.splice(index, 1);
              this.fileSource = new MatTableDataSource(this.fileSource.data);
            }
          });
      }
    }
  }

  /**
   *on close call method
   *
   * @memberof DocumentuploadComponent
   */
  onNoClick(): void {
    this.dialogRef.close();
  }
  viewFile(element) {
    const fileExtension = element.fileName.split(".").pop();
    if (fileExtension === "xlsx" || fileExtension === "doc") {
      this.downloadFile(element);
    } else {
      const dialogRef = this.dialog.open(ViewDocumentComponent, {
        height: "80vh",
        width: "50%",
        data: { value: element.id },
      });
      this.subscriptionList.add(dialogRef.afterClosed().subscribe(() => {}));
    }
  }
  getDocTypeList(){
    this.appBaseService.setResourceURL(MICROSERVICES.DOC_SERVICE);
    this.appBaseService
      .getResource(APPLICATIONSERVICE.DOCUMENT_TYPE_CATEGORY_VIS,true )
      .pipe(takeUntil(this._onDestroy))
      .subscribe((res) => {
        this.docList = res;
      });
    }
}
